import { Popover } from "@mui/material";
import React, { createElement, FunctionComponent, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IventisErrorBoundaryWithToast } from "@iventis/error-boundaries";
import { toast } from "@iventis/toasts/src/toast";
import { PopoverComponents } from "./state/sidebar.slice.types";
import { RootDispatch, RootState } from "./state/root.store";
import { sidebar } from "./state/sidebar.slice";
import { popoverComponents } from "./popover-list";
import { MapTourContext, MapTourStep } from "./map-tour";

export const PopoverComponent: FunctionComponent<{ sidebarPopoverAnchor: Element }> = ({ sidebarPopoverAnchor }) => {
    const { popover, popoverOpen } = useSelector((s: RootState) => s.sidebarReducer);
    const { ref: mapTourRef } = useContext(MapTourContext);
    const dispatch: RootDispatch = useDispatch();
    const closePopover = () => {
        // Once we have saved our map view and we have the tour running on the background step, reopen it
        if (
            popover.component === PopoverComponents.SEARCH &&
            mapTourRef?.current &&
            mapTourRef.current.isRunning() &&
            (mapTourRef.current.getStep() === MapTourStep.LOCATION || mapTourRef.current.getStep() === MapTourStep.BACKGROUND)
        ) {
            mapTourRef.current.maximiseTour();

            // We may have already progressed to the next step depending if we clicked through the spotlight or not
            if (mapTourRef.current.getStep() === MapTourStep.LOCATION) mapTourRef.current.nextStep();
        }
        dispatch(sidebar.actions.closePopover());
    };

    return (
        <Popover
            style={{ transform: `translateY(${popover.translateY})` }}
            open={popoverOpen}
            anchorEl={sidebarPopoverAnchor}
            onClose={closePopover}
            anchorOrigin={popover.anchorOrigin}
            transformOrigin={popover.transformOrigin}
        >
            <IventisErrorBoundaryWithToast toast={toast}>{popoverOpen && createElement(popoverComponents[popover.component], { ...popover.props })}</IventisErrorBoundaryWithToast>
        </Popover>
    );
};
